export default "__VITE_ASSET__CUlraRsQ__"